import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { detectCountry } from "../../hoc/Shared/utility";
//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { connect } from "react-redux";
import { getUserData } from "../../store/ducks/currentUser/actions";

let dynamicCountry = detectCountry(window.location.host);

class MobileBottomNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // login: localStorage.getItem("accessToken") ? true : false, // bug here, state not updated as expected

      // Switch Event Theme
      currentEvent: "",
    };
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };


  render() {
    const { t } = this.props;
    const img = this.imageImport(
      require.context(
        "../../assets/images/mobile-bottom-nav/",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );
    const vipIcon = this.imageImport(
      require.context(
        "../../assets/images/mobile-page-header/",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );
    const christmas = this.imageImport(
      require.context(
        "../../assets/images/home/christmas",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );
    const chinese = this.imageImport(
      require.context(
        "../../assets/images/home/chinese",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );

    const raya = this.imageImport(
      require.context(
        "../../assets/images/home/raya",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );

    const merdeka = this.imageImport(
      require.context(
        "../../assets/images/home/merdeka",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );

    const mooncake = this.imageImport(
      require.context(
        "../../assets/images/home/mooncake",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );

    const halloween = this.imageImport(
      require.context(
        "../../assets/images/home/halloween",
        false,
        /\.(png|jpe?g|svg|webp)$/
      )
    );

    return (
      <Auxiliary>
        <section className={`bottom-nav-section 
          ${
            this.state.currentEvent === "mooncake"? "mooncake" :
            this.state.currentEvent === "cny"? "cny" :
            this.state.currentEvent === "christmas" && "christmas"
          }`}>
          <ul className="bottom-nav-content">
            <li>
              <NavLink
                to={{ pathname: "/promos" }}
                className="nav-link"
                activeClassName="active"
              >
                <>
                  <img
                    className="bottom-icon"
                    // src={img["promo-icon-bottom-nav-mobile.webp"]}
                    src={'https://static.x33.online/r77/images/cny_2026/mobile/before-select/BeforeSelect_Promo.svg'}
                    alt="promo icon"
                  />
                  <img
                    className="bottom-icon-active"
                    // src={img["promo-icon-bottom-nav-mobile-active.webp"]}
                    src={'https://static.x33.online/r77/images/cny_2026/mobile/after-select/AfterSelect_Promo.svg'}
                    alt="promo icon active"
                  />
                </>
                {t("page-header.promos")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={{ pathname: "/sponsor" }}
                className="nav-link"
                activeClassName="active"
                style={{pointerEvents: "none"}}
              >
                <>
                  <span>{t("global.stay-tuned")}</span>
                  <img
                    className="bottom-icon"
                    // src={img["sponsor-icon-bottom-nav-mobile.webp"]}
                    src={'https://static.x33.online/r77/images/cny_2026/mobile/before-select/BeforeSelect_Sponsor.svg'}
                    alt="sponsor icon"
                  />
                  <img
                    className="bottom-icon-active"
                    // src={img["sponsor-icon-bottom-nav-mobile-active.webp"]}
                    src={'https://static.x33.online/r77/images/cny_2026/mobile/after-select/AfterSelect_Sponsor.svg'}
                    alt="sponsor icon active"
                  />
                </>
                {t("global.sponsor")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={{ pathname: `/online-live-games-${dynamicCountry.label}` }}
                className="nav-link home-btn"
                activeClassName="active"
              >
                <>
                  <img
                    className="bottom-icon"
                    // src={img["home-icon-bottom-nav-mobile.webp"]}
                    src={'https://static.x33.online/r77/images/cny_2026/mobile/before-select/BeforeSelect_Home.svg'}
                    alt="home icon"
                  />
                  <img
                    className="bottom-icon-active"
                    // src={img["home-icon-bottom-nav-mobile-active.webp"]}
                    src={'https://static.x33.online/r77/images/cny_2026/mobile/after-select/AfterSelect_Home.svg'}
                    alt="home icon active"
                  />
                </>
              </NavLink>
            </li>

            <li>
              <NavLink
                to={{ pathname: "/#" }}
                onClick={window["liveChatButton"]}
                className="nav-link"
                activeClassName="active"
              >
                <>
                  <img
                    className="bottom-icon"
                    // src={img["chat-icon-bottom-nav-mobile.webp"]}
                    src={'https://static.x33.online/r77/images/cny_2026/mobile/before-select/BeforeSelect_LiveChat.svg'}
                    alt="chat icon"
                  />
                  <img
                    className="bottom-icon-active"
                    // src={img["chat-icon-bottom-nav-mobile-active.webp"]}
                    src={'https://static.x33.online/r77/images/cny_2026/mobile/after-select/AfterSelect_LiveChat.svg'}
                    alt="chat icon active"
                  />
                </>

                {t("contact-us.live-chat")}
              </NavLink>
            </li>
            {!localStorage.getItem('accessToken') ? (
              <li>
                <NavLink
                  to={{ pathname: "/vip" }}
                  className="nav-link"
                  activeClassName="active"
                >
                  <>
                    <img
                      className="bottom-icon"
                      // src={vipIcon["vip-icon-home-mobile.webp"]}
                      src={'https://static.x33.online/r77/images/cny_2026/mobile/before-select/BeforeSelect_Me.svg'}
                      alt="vip icon"
                    />
                    <img
                      className="bottom-icon-active"
                      // src={vipIcon["vip-icon-home-mobile-active.webp"]}
                      src={'https://static.x33.online/r77/images/cny_2026/mobile/after-select/AfterSelect_Me.svg'}
                      alt="vip icon active"
                    />
                  </>
                  {t("page-header.vip")}
                </NavLink>
              </li>
            ) : (
              <li>
                <NavLink
                  to={{ pathname: "/me" }}
                  className="nav-link"
                  activeClassName="active"
                >
                  <>
                    <img
                      className="bottom-icon w-auto"
                      // src={img["me-icon-bottom-nav-mobile.webp"]}
                      src={'https://static.x33.online/r77/images/cny_2026/mobile/before-select/BeforeSelect_Me.svg'}
                      alt="show pwd"
                    />
                    <img
                      className="bottom-icon-active w-auto"
                      // src={img["me-icon-bottom-nav-mobile-active.webp"]}
                      src={'https://static.x33.online/r77/images/cny_2026/mobile/after-select/AfterSelect_Me.svg'}
                      alt="show pwd"
                    />
                  </>
                  {t("global.me")}
                </NavLink>
              </li>
            )}
          </ul>
        </section>
      </Auxiliary>
    );  
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser.data,
  };
};

const mapDispatchToProps = {
  getUserData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(MobileBottomNav));
